import * as React from 'react';

import { ColumnDatatable } from '@europrocurement/flexy-datatable';
import { FactureAchat } from '@europrocurement/l2d-domain';
import { Typography } from '@mui/material';

/**
 * Column definitions for invoices list
 */
export const invoiceColumns: ColumnDatatable<FactureAchat>[] = [
    {
        label: 'N° de facture',
        render: ({ numeroFacture }) => numeroFacture,
        isDisplayed: true,
        field: 'numeroFacture',
    },
    {
        label: 'Date facture',
        render: ({ dateFacture }) => {
            let faFactureDate = null;

            if (dateFacture) {
                faFactureDate = new Date(Date.parse(dateFacture)).toLocaleDateString();
            }

            return <Typography>{faFactureDate}</Typography>;
        },
        isDisplayed: true,
        field: 'dateFacture',
        sortable: true,
    },
];
